module.exports = __webpack_public_path__ + "img/dis-icon2.bbaf6e08.png";